// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.disponivel[data-v-aa3efaee] {\n    background: repeating-linear-gradient(\n        45deg,\n        #adff2f,\n        #adff2f 1px,\n        #fff 2px,\n        #fff 6px\n    )\n}\n.table-hour tr[data-v-aa3efaee]:hover {\nbackground-color: transparent !important;\n}\n.table-hour td[data-v-aa3efaee]:hover {\n    background-color: rgb(242, 248, 248);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
